import { useCallback } from "react";
import BackgroundProgressiveImg from "app/pages/.shared/BackgroundProgressiveImg.jsx";
import { ficheProduitPropTypes } from "app/utils/propTypes";
import { pushTagOnProductViewButtonClick } from "app/utils/analytics";
import "./ProductOriginal.scss";
import { OFFER_CONTRACT_TYPES } from "app/constants";
import BadgeList from "app/pages/.shared/ColoredProductBadge/BadgeList";
import ProductDestinationTitleContainer from "app/pages/.shared/ProductDestinationTitle/ProductDestinationTitleContainer";
import ProductNameWithCategory from "app/pages/.shared/ProductNameWithCategory/ProductNameWithCategory";
import ProductLinkContainer from "app/pages/.shared/ProductLink/ProductLinkContainer";
import IconRight from "app/pages/.shared/static/icons/IconRight";
import ProductDeal from "app/pages/.shared/Deal/ProductDeal";

const IMG_SIZES = {
	small: { height: 510 },
	medium: { height: 510 },
	large: { height: 510 },
	xlarge: { height: 510 },
};

const CLOUDINARY_OPTIONS = ["c_fill"];

const Jumbotron = ({ product = {} }) => {
	const handleProductClick = useCallback(() => {
		pushTagOnProductViewButtonClick(product, 0);
	}, []);

	const mainPhoto = product.photos && product.photos[0];

	return (
		<div className="product product--spotlighted" data-testid="product">
			<div className="product__picture">
				<ProductLinkContainer
					handleProductClick={handleProductClick}
					productUri={product.uri}
				>
					<BackgroundProgressiveImg
						sizes={IMG_SIZES}
						cloudinaryOptions={CLOUDINARY_OPTIONS}
						src={mainPhoto?.url}
						thumbnail={mainPhoto?.thumbnail}
					/>
				</ProductLinkContainer>
			</div>
			<div className="product__deal">
				<ProductDeal
					isRental={product.contractType === OFFER_CONTRACT_TYPES.RENTAL}
					publicPrice={product.fromPriceType?.publicPrice}
					price={product.fromPriceType?.price}
					includeOfferWithFlight={product.includeOfferWithFlight}
					duration={product.fromPriceType?.numberOfNights}
					hour={product.expiration?.hour}
					day={product.expiration?.day}
					type={product.fromPriceType?.type}
					value={product.fromPriceType?.value}
				/>
			</div>
			<div className="product__footer">
				<div className="product__main">
					<ProductDestinationTitleContainer
						className="product__destination"
						region={product.region}
						resort={product.resort}
						country={product.country}
					/>

					<ProductNameWithCategory
						categoryType={product.categoryType}
						category={product.category}
						name={product.name}
					/>

					{product.badges && product.badges.length > 0 && (
						<div className="product__badges">
							<BadgeList badges={product.badges} />
						</div>
					)}
				</div>
				<div className="product__deal">
					<ProductDeal
						isRental={product.contractType === OFFER_CONTRACT_TYPES.RENTAL}
						publicPrice={product.fromPriceType?.publicPrice}
						price={product.fromPriceType?.price}
						includeOfferWithFlight={product.includeOfferWithFlight}
						duration={product.fromPriceType?.numberOfNights}
						hour={product.expiration?.hour}
						day={product.expiration?.day}
						type={product.fromPriceType?.type}
						value={product.fromPriceType?.value}
					/>
				</div>
				<div className="product__action">
					<ProductLinkContainer
						handleProductClick={handleProductClick}
						productUri={product.uri}
					>
						<IconRight width={20} height={20} />
					</ProductLinkContainer>
				</div>
			</div>
		</div>
	);
};

Jumbotron.propTypes = {
	product: ficheProduitPropTypes,
};

export default Jumbotron;
